import React from 'react';

import BoardContextProvider from './web/Board';

const Board = () => {
  return <BoardContextProvider />;
};

export default Board;
